import { createFileRoute } from '@tanstack/react-router'

import { PlatformOrganizationPage } from '../../../../components/pages/backoffice/platform/platform-organization-page/platform-organization-page.tsx'
import { PermissionChecker } from '../../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/bo/organizations/$organizationTechnicalName/')({
  component: function Component() {
    const { organizationTechnicalName } = Route.useParams()

    return (
      <PermissionChecker requiredPermissions={['organization.view']}>
        <PlatformOrganizationPage organizationTechnicalName={organizationTechnicalName} />
      </PermissionChecker>
    )
  },
})
